(function () {
  function measureAll() {
    document.querySelectorAll(".scrolling-features-bar").forEach(function (section) {
      var track = section.querySelector(".features-track");
      var firstCopy = track && track.querySelector(".feature-items");
      if (!track || !firstCopy) return;
      var copyWidth = firstCopy.offsetWidth;
      if (copyWidth > 0) {
        section.style.setProperty("--scroll-distance", copyWidth + "px");
      }
    });
  }

  measureAll();
  window.addEventListener("resize", measureAll);
  if (document.fonts) {
    document.fonts.ready.then(measureAll);
  }
})();
